import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import z from 'zod'

export const alertsSearchSchema = z.object({
  // enforce site-id is defined
  [SEARCH_PARAM_SITE_ID]: z.string(),

  page: z.number().optional().default(0),
  pageSize: z.number().optional().default(25),
  selectedAlertId: z.string().optional(),
  // Table filter columns
  'data.priority': z.number().optional(),
  'data.timestamp': z
    .tuple([z.string().nullable(), z.string().nullable()])
    .optional(),
  'data.acknowledged': z.array(z.string()).optional(),
  'data.status': z.string().optional(),
  'data.area': z.string().optional(),
  'data.name': z.string().optional(),
  'data.description': z.string().optional(),
  'data.alerted_value': z.number().optional(),
  'data.setpoint': z.number().optional(),
  'data.unit': z.string().optional(),
})
